(() => {
  if (customElements.get('autoplay-video')) {
    return;
  }

  const playIframeVideo = (iframe) => {
    const host = iframe.getAttribute('data-host');
    if (host === 'youtube') {
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"' + 'playVideo' + '","args":""}',
        '*',
      );
      return;
    }

    if (host === 'vimeo') {
      iframe.contentWindow.postMessage('{"method":"play"}', '*');
    }
  }

  const pauseIframeVideo = (iframe) => {
    const host = iframe.getAttribute('data-host');
    if (host === 'youtube') {
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
        '*',
      );
      return;
    }

    if (host === 'vimeo') {
      iframe.contentWindow.postMessage('{"method":"pause"}', '*');
    }
  }

  class AutoplayVideo extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.intersectionObserver = new IntersectionObserver((entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            return;
          }
          this.playVideo();
          this.intersectionObserver.unobserve(this);
        });
      }), { threshold: 0.5 });

      this.intersectionObserver.observe(this);
    }

    playVideo() {
      const videoElement = this.querySelector('video');
      if (videoElement) {
        videoElement.play().catch((error) => {
          console.error('Error attempting to play', error);
        });
        return;
      }
      const iframeElement = this.querySelector('iframe');
      playIframeVideo(iframeElement);
    }

    pauseVideo() {
      const videoElement = this.querySelector('video');
      if (videoElement) {
        videoElement.pause().catch((error) => {
          console.error('Error attempting to play', error);
        });
        return;
      }
      const iframeElement = this.querySelector('iframe');
      pauseIframeVideo(iframeElement);
    }
  }

  customElements.define('autoplay-video', AutoplayVideo);
})();